module.exports = __webpack_public_path__ + "img/connections.7022f863.svg";